<app-inbound-form-wrapper
  data-testid="inbound-result-view-form-wrapper"
  [inboundData]="inboundData"
  [itemDetails]="itemDetails()"
  [viewMode]="true"
  [loading]="loading()"
  [tabType]="'inbound-result'"
  (formAction)="onFormAction($event)"
  (tableAction)="onTableAction($event)"
></app-inbound-form-wrapper>
